import {FetchManager, ConditionalLogic, DropzoneHandler} from 'js-pimcore-formbuilder';
import {EVENTS} from "js-pimcore-formbuilder/src/js/constants/defaults";

class Config {}

Config.HIDE_ELEMENT_CLASS = 'is-hidden';
Config.FORM_BUILDER_MESSAGE_CONTAINER_CLASS = 'notification';
Config.WRAPPER_ELEMENT_CLASS = 'control';
Config.WRAPPER_FIELD_ROW_CLASS = 'formbuilder-row';
Config.FIELD_ROW_CLASS = 'field';
Config.ERROR_CLASS = 'is-danger';
Config.SUCCESS_CLASS = 'is-success';
Config.HIDE_CLASS = 'is-hidden';
Config.ERROR_MESSAGE_ELEMENT = 'p';
Config.FORM_BUILDER_MESSAGE_ELEMENT_TYP = 'div';

const showOrHideElement = function (element, show = true) {
    if (element === null) return;

    const fieldRow = element.closest('.'+Config.WRAPPER_FIELD_ROW_CLASS);

    if (fieldRow === null) return;

    if (show) {
        fieldRow.classList.remove(Config.HIDE_ELEMENT_CLASS);
    } else {
        fieldRow.classList.add(Config.HIDE_ELEMENT_CLASS);
    }
};

const addOrRemoveElementRequired = function (element, add = true) {
    if (element === null) return;

    if (add) {
        element.setAttribute('required', 'required');
    } else {
        element.removeAttribute('required');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form.hs-floating-labels .formbuilder-row-choice > .label, form.hs2-floating-labels .formbuilder-row-choice > .label, form.hs2-floating-labels .formbuilder-row-date > .label, form.hs2-floating-labels .formbuilder-row-time > .label').forEach((labelElement) => {
        labelElement.classList.add('fixed');
    });

    const homeSecurityFloatingForms = Array.from(
        document.querySelectorAll(
            'form.formbuilder.ajax-form.hs-floating-labels,form.formbuilder.ajax-form.hs2-floating-labels',
        ),
    ).filter((form) =>
        form.querySelector('.js-selected-product select,.floating-labels'),
    );

    const ensureSelectPlaceholder = (selectElement) => {
        if (!(selectElement instanceof HTMLSelectElement)) return;
        if (selectElement.multiple) return;
        if (selectElement.dataset.preserveDefault === 'true') return;

        const emptyOption = Array.from(selectElement.options).find((option) => option.value === '');
        if (emptyOption) {
            emptyOption.textContent = '';
            emptyOption.disabled = false;
            emptyOption.hidden = true;

            if (!selectElement.value) {
                emptyOption.selected = true;
                selectElement.value = '';
            }

            return;
        }

        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = '';
        placeholderOption.disabled = false;
        placeholderOption.hidden = true;
        placeholderOption.selected = true;

        selectElement.prepend(placeholderOption);
        selectElement.value = '';
    };

    const updateFloatingState = (element) => {
        const value = element.value ?? '';
        const hasValue = value.trim() !== '';

        if (hasValue) {
            element.closest('.field')?.classList.add('is-floating');
        } else {
            element.closest('.field')?.classList.remove('is-floating');
        }
    };

    homeSecurityFloatingForms.forEach((form) => {
        form.querySelectorAll('select').forEach((selectElement) => {
            // Keep backend/default option texts (e.g. "Bitte wählen") unchanged.
            selectElement.dataset.preserveDefault = 'true';

            ensureSelectPlaceholder(selectElement);
        });

        form.querySelectorAll('input, textarea, select').forEach((element) => {
            element.addEventListener('change', () => {
                updateFloatingState(element);
            });

            element.addEventListener('input', () => {
                updateFloatingState(element);
            });

            updateFloatingState(element);
        });
    });

    document.querySelectorAll('form.formbuilder.ajax-form').forEach((form) => {
        /**
         * Include Fetchmanager
         */
        const fetchManager = new FetchManager(form, {
            elementTransformer: {
                addValidationMessage: (form, field, messages) => {
                    let uploadField = false;
                    let fieldRow = null;
                    let fieldWrapElement = null;
                    let formElement = "INPUT";

                    if (field.id.includes("upload_adapter")) {
                        uploadField = true;
                    }

                    fieldRow = document
                        .querySelector('.' + Config.WRAPPER_FIELD_ROW_CLASS
                            + '.' + field.id + '.' + Config.FIELD_ROW_CLASS);

                    if (uploadField) {
                        const parentFieldEl = field.id.replace("_data", "");
                        fieldWrapElement = document
                            .querySelector('#' + field.id);
                        const uploadFieldContainer = document.querySelector('.' + parentFieldEl + ' .dropzone-container');

                        if (uploadFieldContainer) {
                            uploadFieldContainer.classList.add(Config.ERROR_CLASS);
                        }
                    } else {
                        fieldWrapElement = fieldRow
                            .querySelector('.' + Config.WRAPPER_ELEMENT_CLASS);
                        formElement = field.tagName;
                    }

                    /**
                     * If field is a select the error class will be assigned to wrap class,
                     * otherwise like normally to field.
                     */
                    if (formElement === "SELECT") {
                        fieldWrapElement.querySelector('.select').classList.add(Config.ERROR_CLASS);
                    } else {
                        field.classList.add(Config.ERROR_CLASS);
                    }

                    let newNode = document.createElement(Config.ERROR_MESSAGE_ELEMENT)
                    newNode.classList.add('help', Config.ERROR_CLASS)
                    newNode.textContent = messages

                    if (uploadField) {
                        fieldWrapElement.after(newNode)
                    } else {
                        fieldWrapElement.append(newNode)
                    }
                },
                removeFormValidations: (form) => {
                    form
                        .querySelectorAll(Config.ERROR_MESSAGE_ELEMENT + '.' + Config.ERROR_CLASS)
                        .forEach((el) => el.remove());
                    form
                        .querySelectorAll('.' + Config.ERROR_CLASS)
                        .forEach((el) => el.classList.remove(Config.ERROR_CLASS));
                }
            },
            onSuccess: (messages, redirect, form) => {
                let messageText = messages
                    .filter((message) => message.type == "success");

                if (redirect !== null && messageText.length > 0) {
                    document.location.href = redirect;
                } else {
                    const messageContainer = document.createElement(Config.FORM_BUILDER_MESSAGE_ELEMENT_TYP);

                    form.classList.add(Config.HIDE_CLASS);

                    if (messageText.length > 0) {
                        messageContainer.classList.add(Config.FORM_BUILDER_MESSAGE_CONTAINER_CLASS, Config.SUCCESS_CLASS);
                        messageText = messageText.map((it) => it.message);
                        messageContainer.innerHTML = messageText.join("<br>");

                        form.after(messageContainer);
                    }
                }
            }
        });

        /**
         * Adapt fetchManager onFail method to transform the messages into the form which is accepted by dropzone plugin
         * @param form
         * @param data
         */
        fetchManager.onFail = function(form, data) {
            if (data.hasOwnProperty("validation_errors")) {
                for (let field in data.validation_errors) {
                    const constraint = data['validation_errors'][field];

                    if (field.includes("general")) {
                        const fieldMessage = data['validation_errors'][field];

                        fieldMessage.forEach(message => {
                            const validationOpts = message.split("##")

                            if (validationOpts.length > 1) {
                                data['validation_errors'][form.name + "_" + validationOpts[0] + "_adapter_data"] = validationOpts[1];
                            }
                        });
                    }

                    if (field.includes("upload")) {
                        data['validation_errors'][field + "_adapter_data"] = constraint;
                    }
                }

                /**
                 * On every occurred error we will display the file remove button,
                 * to give the possibility for omitting it.
                 */
                const attachmentsRemoveBtns = form.querySelectorAll('.dz-remove');

                if (attachmentsRemoveBtns) {
                    attachmentsRemoveBtns.forEach(attchmntEl => {
                        attchmntEl.style.display = "";
                    })
                }
            }

            this.options.onFail(data, form);
            form.dispatchEvent(
                new CustomEvent(EVENTS.error, {
                        detail: {
                            response: data
                        }
                    }
                )
            );
        }

        /**
         * Include Conditional logic
         */
        new ConditionalLogic(form, {
            elementTransformer: {
                show(el) {
                    showOrHideElement(el);
                },
                hide(el) {
                    showOrHideElement(el, false);
                },
                addClass(el, className) {
                    el.classList.add(className)
                },
                removeClass(el, className) {
                    el.classList.remove(className)
                },
                addRequiredState: (el) => {
                    addOrRemoveElementRequired(el)
                },
                removeRequiredState: (el) => {
                    addOrRemoveElementRequired(el, false)
                }
            },
            hideElementClass: Config.HIDE_ELEMENT_CLASS
        });

        form.querySelectorAll('input, select, textarea').forEach((element) => {
            element.dispatchEvent(new Event('change'));
        });

        /**
         * Include dropzone for multifile upload
         */
        const dropZoneHandler = new DropzoneHandler(form, {
            addRemoveLinks: true,
            suspendFileRemoval: true,
            dropzoneOptions: {
                chunking: false
            }
        });

        if (dropZoneHandler) {
            let totalUploadFilesSize;

            /**
             * Overwriting of Update Total Upload Progress
             * We need it to set into the form total size of uploaded files for next validation
             * @returns {Dropzone}
             */
            Dropzone.prototype.updateTotalUploadProgress = function() {
                let totalUploadProgress;
                let totalBytesSent = 0;
                let totalBytes = 0;

                let activeFiles = this.getActiveFiles();

                if (activeFiles.length) {
                    for (let file of this.getActiveFiles()) {
                        totalBytesSent += file.upload.bytesSent;
                        totalBytes += file.upload.total;
                    }
                    totalUploadProgress = (100 * totalBytesSent) / totalBytes;
                } else {
                    totalUploadProgress = 100;
                }

                const totalSizeElClassName = fetchManager.form.name + "_files_total_upload_size";
                const totalSizeEl = fetchManager.form.querySelector("." + totalSizeElClassName);
                totalSizeEl.value = 0;

                if (this.files.length) {
                    totalUploadFilesSize = 0;

                    this.files.forEach(file => {
                        if (file.accepted) {
                            totalUploadFilesSize = totalUploadFilesSize + file.size;
                        }
                    })

                    totalSizeEl.value = totalUploadFilesSize;
                }

                return this.emit(
                    "totaluploadprogress",
                    totalUploadProgress,
                    totalBytes,
                    totalBytesSent
                );
            }
        }
    });
});